import React from "react";
import Partner01 from "../assets/redesign/partners/partner-01@2x.png";
import Partner02 from "../assets/redesign/partners/partner-02@2x.png";
import Partner03 from "../assets/redesign/partners/partner-03@2x.png";
import Partner04 from "../assets/redesign/partners/partner-04@2x.png";
import Partner05 from "../assets/redesign/partners/partner-05@2x.png";
import Partner06 from "../assets/redesign/partners/partner-06@2x.png";
import Partner07 from "../assets/redesign/partners/partner-07@2x.png";
import Partner08 from "../assets/redesign/partners/partner-08@2x.png";
import Partner09 from "../assets/redesign/partners/partner-09@2x.png";

const partners = [Partner01, Partner02, Partner03, Partner04, Partner05, Partner06, Partner07, Partner08, Partner09];

export default function PartnersSection() {
  return (
    <section className="partners" aria-label="HereWeAre partners">
      <div className="partners__track">
        {[0, 1].map((groupIndex) => (
          <div className="partners__group" key={groupIndex} aria-hidden={groupIndex === 1}>
            {partners.map((partner, index) => (
              <div className="partners__logo" key={`${groupIndex}-${index}`}>
                <img src={partner} alt="" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
